import React, { useCallback, useEffect, useMemo, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";
// import { FormattedDate, FormattedMessage } from "react-intl";
import { Navigation } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";
import styles from "./index.module.scss";
import arrowBig from "@/src/assets/images/svg/arrow-big.svg";
import { useRouter } from "next/router";
import { handleImage } from "../../handlers";
// import { FormattedDate, FormattedMessage } from "react-intl";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import dynamic from "next/dynamic";
import { Document, Page } from "react-pdf";

import { pdfjs } from "react-pdf";
import Filters from "./filters";
import { set } from "react-hook-form";
import { handleImageLink } from "../../helpers/functions";
// import Lightbox from "../../Shared/Lightbox";
import PdfDownloadIcon from "../../../assets/images/svg/download.svg";
import ExpandIcon from "../../../assets/images/svg/expand.svg";
import SarIcon from "../../../assets/images/svg/sar.svg";
import RequestForm from "../../Shared/RequestForm";

const FormattedMessage = dynamic(
  () => import("react-intl").then((mod) => mod.FormattedMessage),
  {
    ssr: false,
  },
);

export default function Categories({
  data,
  page = "",
  filterSlug = "",
  breakPoints = false,
  sliderProps = {},
}) {
  const { locale, query } = useRouter();
  const dir = locale == "ar" ? "rtl" : "ltr";
  const [slideInfo, setSlideInfo] = useState({});
  const [slideNum, setSlideNum] = useState(0);
  const [items, setItems] = useState(data);

  const [displayPagination, setDisplayPagination] = useState(false);
  const [displayFilters, setDisplayFilters] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const [expandedImage, setExpandedImage] = useState("");
  const [isRequestOpen, setIsRequestOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const handlePdfDownload = async (item) => {
    const pdfUrl = item?.name?.file;

    const response = await fetch(pdfUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${item?.name?.ar}.pdf`;
    link.click();

    window.URL.revokeObjectURL(link.href);
  };

  const handleExpandImage = (item) => {
    const imageUrl = handleImageLink(item?.name?.pdfImage);
    if (!imageUrl) return;

    setExpandedImage(imageUrl);
  };

  const handleOpenRequestModal = (person) => {
    setSelectedPerson(person);
    setIsRequestOpen(true);
  };

  const projectsTopRef = React.useRef(null);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
  }, []);
  useEffect(() => {
    const filtered = data?.items?.filter(
      (item) => item.country?.id === query?.country,
    );
    setItems(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  useEffect(() => {
    setPageNum(0);
  }, [items]);

  const renderProjectItems = useMemo(
    () =>
      items?.length > 0 ? (
        items?.slice(pageNum * 9, (pageNum + 1) * 9)?.map((item, k) => {
          if (item?.available)
            return (
              <SwiperSlide key={"project" + k}>
                <div className="personnel">
                  <div className="img">
                    <Image
                      src={handleImageLink(item?.name?.pdfImage)}
                      alt=""
                      width={500}
                      height={500}
                    />
                    <button
                      type="button"
                      className="pdf-btn"
                      onClick={() => handlePdfDownload(item)}
                    >
                      <Image
                        src={PdfDownloadIcon}
                        alt=""
                        width={16}
                        height={16}
                      />
                      <FormattedMessage id="downloadPdf" />
                    </button>
                    <button
                      type="button"
                      className="expand-btn"
                      onClick={() => handleExpandImage(item)}
                    >
                      <Image src={ExpandIcon} alt="" width={16} height={16} />
                      <FormattedMessage id="expandImage" />
                    </button>
                  </div>
                  <div className="info">
                    <h3>{item?.name?.[locale]}</h3>

                    <ul>
                      <li>
                        <span className="key">
                          <FormattedMessage id="nationality" />:{" "}
                        </span>
                        {item?.country?.name?.[locale]}
                      </li>
                      <li>
                        <span className="key">
                          <FormattedMessage id="code" />:
                        </span>
                        {item?.id}
                      </li>

                      <li>
                        <span className="key">
                          <FormattedMessage id="religion" />:{" "}
                        </span>
                        {item?.religion?.[locale]}
                      </li>
                      <li>
                        <span className="key">
                          <FormattedMessage id="experienceYears" />:{" "}
                        </span>
                        {item?.name?.experienceYears}
                      </li>
                      <li>
                        <span className="key">
                          <FormattedMessage id="age" />:
                        </span>
                        {item?.age} <FormattedMessage id="year" />
                      </li>
                      <li>
                        <span className="key">
                          <FormattedMessage id="job" />:
                        </span>
                        {item?.job?.[locale]}
                      </li>
                      {item?.salary && (
                        <li>
                          <span className="key">
                            <FormattedMessage id="monthlySalary" />:
                          </span>{" "}
                          {item?.salary}
                          <Image
                            src={SarIcon}
                            alt=""
                            width={18}
                            height={18}
                            className="mx-1"
                          />
                        </li>
                      )}
                      {item?.recruitmentFees && (
                        <li>
                          <span className="key">
                            <FormattedMessage id="recruitmentFees" />:
                          </span>{" "}
                          {item?.recruitmentFees}
                          <Image
                            src={SarIcon}
                            alt=""
                            width={18}
                            height={18}
                            className="mx-1"
                          />
                        </li>
                      )}
                    </ul>
                    <div className="btns d-flex align-items-center justify-content-between gap-3">
                      <button
                        type="button"
                        className="open-request-modal nw-btn"
                        onClick={() => handleOpenRequestModal(item)}
                      >
                        <FormattedMessage id="recruitmentRequest" />
                      </button>
                      <Link href={`/personnel/${item?.id}`} legacyBehavior>
                        <a className="details-link nw-btn">
                          <FormattedMessage id="viewDetails" />
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
        })
      ) : (
        <div className="alert alert-warning">
          <FormattedMessage id="noDataFound" />
        </div>
      ),
    [items, pageNum, locale],
  );
  const itemsPerPage = 9;
  const totalPages = Math.ceil(items?.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setIsPageLoading(true);
    setPageNum(newPage);
    projectsTopRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setTimeout(() => {
      setIsPageLoading(false);
    }, 300);
  };

  const slidingbuttons = totalPages > 1 && (
    <div className="custom-pagination wrapper">
      <div className="pagination-wrapper">
        {/* Next button */}
        <div
          className={`swiper_button_next gradient-btn ${
            pageNum + 1 >= totalPages ? "disable" : ""
          }`}
          onClick={() =>
            pageNum + 1 < totalPages && handlePageChange(pageNum + 1)
          }
        >
          <Image {...arrowBig} alt="" />
        </div>

        {/* Page numbers */}
        <div className="row">
          {Array.from({ length: totalPages }).map((_, index) => (
            <div
              className={`w-auto pagination-num ${
                pageNum === index ? "text-decoration-underline" : ""
              }`}
              key={index}
              onClick={() => handlePageChange(index)}
            >
              <span className="cursor-pointer">{index + 1}</span>
            </div>
          ))}
        </div>

        {/* Previous button */}
        <div
          className={`swiper_button_prev gradient-btn ${
            pageNum === 0 ? "disable" : ""
          }`}
          onClick={() => pageNum > 0 && handlePageChange(pageNum - 1)}
        >
          <Image {...arrowBig} alt="" />
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.projects}>
      <Row>
        <Col>
          {page != "categories" ? (
            <>
              <div className="wrapper">
                <Row className="justify-content-center justify-content-md-between inff">
                  <div className="w-auto">
                    {page != "id" ? (
                      <div className="pb-1 ">
                        <span className="section-tag text-start">
                          <FormattedMessage id="categories" />
                        </span>
                      </div>
                    ) : (
                      <>
                        <div className="pb-1 m-auto">
                          <span className="section-tag text-center">
                            <FormattedMessage id="other-projects" />
                          </span>
                        </div>
                        <h3 className="unique-bold text-black">
                          <FormattedMessage id="more-projects" />
                        </h3>
                      </>
                    )}
                    <h3 className="unique-bold text-black">
                      {data?.heading?.[locale] || ""}
                    </h3>
                  </div>
                  <div className="w-auto show-projects-link align-self-end">
                    <Link
                      href="/categories"
                      className="btn w-auto"
                      aria-label="categories-link"
                    >
                      <FormattedMessage id="all-categories" />
                      <div>
                        <Image {...arrowBig} alt="" />
                      </div>
                    </Link>
                  </div>
                </Row>
              </div>
              <Row className="swiperWrapper container-p-start w-100 m-0  ">
                <Swiper
                  onSlideChange={(e) => {
                    setSlideInfo(e);
                    setSlideNum(e?.activeIndex);
                    // console.log("slideInfo", e);
                  }}
                  runCallbacksOnInit={true}
                  onInit={(e) => {
                    e?.snapGrid?.length > 1 && setDisplayPagination(true);
                  }}
                  dir={dir}
                  effect={"fade"}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  slidesPerView={1}
                  spaceBetween={25}
                  breakpoints={
                    breakPoints
                      ? breakPoints
                      : {
                          375: {
                            slidesPerView: 1,
                          },
                          425: {
                            slidesPerView: 1.2,
                          },
                          500: {
                            slidesPerView: 1.4,
                          },
                          565: {
                            slidesPerView: 1.5,
                          },
                          695: {
                            slidesPerView: 2,
                          },
                          788: {
                            slidesPerView: 2.3,
                          },
                          950: {
                            slidesPerView: 2.7,
                          },
                          1140: {
                            slidesPerView: 3,
                          },
                          1340: {
                            slidesPerView: 3.4,
                          },
                          1494: {
                            slidesPerView: 3.7,
                          },
                          1740: {
                            slidesPerView: 4.7,
                          },
                          1940: {
                            slidesPerView: 5,
                          },
                          2420: {
                            slidesPerView: 6.2,
                          },
                        }
                  }
                  navigation={{
                    nextEl: `.swiper_button_next`,
                    prevEl: `.swiper_button_prev`,
                  }}
                  modules={[Navigation]}
                  {...sliderProps}
                >
                  {renderProjectItems}
                </Swiper>

                <div
                  className={`custom-pagination container-p-start ${
                    !displayPagination && "hidden"
                  }`}
                >
                  <div className="pagination-wrapper text-black">
                    <div className={`swiper_button_next gradient-btn`}>
                      <Image {...arrowBig} alt="" />
                    </div>
                    <FormattedMessage id="next" />

                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${slideInfo?.progress * 100}%`,
                        }}
                        aria-label="Progress bar"
                      >
                        <span className="sr-only"> </span>
                      </div>
                    </div>
                    <FormattedMessage id="prev" />
                    <div className={`swiper_button_prev gradient-btn `}>
                      <Image {...arrowBig} alt="" />
                    </div>
                  </div>
                </div>
              </Row>
            </>
          ) : (
            <div>
              {!query?.country && (
                <Filters
                  data={items}
                  rawData={data?.items}
                  setData={setItems}
                />
              )}
              <div ref={projectsTopRef} className="projects-page-wrapper">
                {isPageLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  renderProjectItems
                )}
              </div>
              {slidingbuttons}
            </div>
          )}
          {expandedImage && (
            <div className="zoom-image" onClick={() => setExpandedImage("")}>
              <Image src={expandedImage} width={1200} height={1200} alt="" />
            </div>
          )}
          {isRequestOpen && (
            <div
              className="request-modal"
              onClick={() => setIsRequestOpen(false)}
            >
              <div
                className="request-modal-content"
                onClick={(event) => event.stopPropagation()}
              >
                <div className="request-modal-header">
                  <h3>
                    <FormattedMessage id="recruitmentRequest" />
                  </h3>
                  <button
                    type="button"
                    className="request-modal-close"
                    onClick={() => setIsRequestOpen(false)}
                    aria-label="close"
                  >
                    ×
                  </button>
                </div>
                <RequestForm
                  countries={data ? [data] : []}
                  person={selectedPerson}
                  onSuccess={() => setIsRequestOpen(false)}
                />
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
